export default __webpack_public_path__ + "static/wallpaper-3-pc-553d5697f7ad3820c030877a275f023f.png";